import React from 'react';
import { type Device, localColumnSorter } from '../columns';
import { type TableState } from '../../components/table';

export default function useReduceTableState(
  devices: {
    outdated: Device[],
    unauthenticated: Device[]
  },
  unAuthTableState: TableState,
  outDatedTableState: TableState,
) {
  const [outdated, setOutdated] = React.useState(devices.outdated);
  const [unauthenticated, setUnauthenticated] = React.useState(devices.unauthenticated);

  React.useEffect(() => {
    const sorted = localColumnSorter(devices.unauthenticated, unAuthTableState.sort, unAuthTableState.sortDirection);
    setUnauthenticated(sorted);
  }, [unAuthTableState.sort, unAuthTableState.sortDirection]);

  React.useEffect(() => {
    const sorted = localColumnSorter(devices.outdated, outDatedTableState.sort, outDatedTableState.sortDirection);
    setOutdated(sorted);
  }, [outDatedTableState.sort, outDatedTableState.sortDirection]);

  return ({ outdated, unauthenticated });
}
